import React from 'react';
import {LineamientosNew} from "../components/lineamientos/LineamientosNew";

const LineamientosPage = () => (
    <div>
        <LineamientosNew/>
    </div>
);

export default LineamientosPage;